import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {formatPhoneNumber} from 'src/shared/utils/formatPhoneNumber';
import {a11yHidden} from 'src/styles/modules/a11y.module.scss';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import {header} from '../header.module.scss';
import {
  fieldset,
  selectWrap,
} from './style.module.scss';

export const ScheduleCallView = ({
  availableTimes,
  day,
  email,
  onCancel,
  onDayChange,
  onEmailChange,
  onPhoneChange,
  onSubmit,
  onTimeslotChange,
  phone,
  timeslot,
  timeslots,
}) => {
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const phoneErrorMessage = 'Please enter a valid phone number.';
  const emailErrorMessage = 'Please enter a valid email address.';

  const handleDayChange = ({target: {value}}) => {
    if (value !== day) {
      onDayChange(value);
    }
  };

  const onPhoneBlur = () => {
    if (phone.length !== 10) {
      setIsPhoneError(true);
    } else {
      setIsPhoneError(false);
    }
  };

  const onEmailBlur = () => {
    if (!email.match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')) {
      setIsEmailError(true);
    } else {
      setIsEmailError(false);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (isPhoneError || !phone) {
      setIsPhoneError(true);
    } else if (isEmailError || !email) {
      setIsEmailError(true);
    } else {
      onSubmit();
    }
  };

  return (
    <>
      <header className={header}>
        <h1>We&apos;ll give you a call</h1>
        <p>Is this still the best way to reach you?</p>
      </header>
      <form>
        <fieldset className={fieldset}>
          <legend className={a11yHidden}>Contact Information</legend>
          <div>
            <label htmlFor="phone-number">Call me at:</label>
            <div style={{marginBottom: '2.4rem'}}>
              <input style={{marginBottom: 0}} id="phone-number" name="phone-number" placeholder="(###) ###-####" value={formatPhoneNumber(phone)} onChange={event => onPhoneChange(event.target.value)} onBlur={onPhoneBlur} />
              {isPhoneError && <span style={{color: 'red'}}>{phoneErrorMessage}</span>}
            </div>
          </div>
          <div>
            <label htmlFor="email">Email address:</label>
            <div style={{marginBottom: '2.4rem'}}>
              <input data-notranslate="true" style={{marginBottom: 0}} id="email" name="email" value={email} onChange={event => onEmailChange(event.target.value)} onBlur={onEmailBlur} />
              {isEmailError && <span style={{color: 'red'}}>{emailErrorMessage}</span>}
            </div>
          </div>
          <label htmlFor="day">What day works best?</label>
          <div className={selectWrap}>
            <select
              id="day"
              name="day"
              onBlur={handleDayChange}
              onChange={handleDayChange}
              value={day}
            >
              {
                timeslots.map((timeslot, index) => (
                  <option key={timeslot.date} value={index}>{timeslot.text}</option>
                ))
              }
            </select>
          </div>
          <label htmlFor="time">What time should we call you?</label>
          <div className={selectWrap}>
            <select
              id="time"
              name="time"
              onBlur={event => onTimeslotChange(event.target.value)}
              onChange={event => onTimeslotChange(event.target.value)}
              value={timeslot}
            >
              {
                availableTimes.map(time => (
                  <option key={time.value} value={time.value}>{time.text}</option>
                ))
              }
            </select>
          </div>
        </fieldset>
        <div className={buttonGroup}>
          <button id="submitButton" className={`${button} ${primary}`} onClick={event => handleSubmit(event)} type="button">Submit</button>
          <button className={button} onClick={onCancel} type="button">Cancel</button>
        </div>
      </form>
    </>
  );
};

ScheduleCallView.propTypes = {
  availableTimes: PropTypes.array.isRequired,
  day: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDayChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onPhoneChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onTimeslotChange: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  timeslot: PropTypes.string.isRequired,
  timeslots: PropTypes.array.isRequired,
};
